import { useEffect, useState } from "react";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";

// Convert a pasted video URL (YouTube / Vimeo / direct .mp4) to an embeddable source.
const videoEmbed = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return { type: "iframe", src: `https://www.youtube.com/embed/${yt[1]}` };
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return { type: "iframe", src: `https://player.vimeo.com/video/${vm[1]}` };
  return { type: "video", src: url };
};

export default function VideoPorDentro() {
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    api.get("/public-settings")
      .then(({ data }) => setVideoUrl(data.home_video_url || ""))
      .catch(() => {});
  }, []);

  const embed = videoEmbed(videoUrl);
  if (!embed) return null;

  return (
    <section id="video" data-testid="video-section" className="py-20 md:py-28 bg-[#FAF9F6]">
      <div className="max-w-6xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <Reveal>
          <p className="overline mb-6">En vídeo</p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
            Mira cómo es por dentro.
          </h2>
          <p className="text-[#6B705C] mt-5 font-light leading-relaxed max-w-md">
            Dale al play y descubre cada página: el índice de especialidades, los separadores
            ilustrados a mano y el hueco para todo tu historial médico.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div
            data-testid="home-video"
            className="rounded-3xl overflow-hidden border border-[#EBEBEB] bg-black aspect-[4/5] w-full max-w-md mx-auto shadow-[0_24px_60px_-24px_rgba(45,55,50,0.35)]"
          >
            {embed.type === "iframe" ? (
              <iframe
                src={embed.src}
                title="VITAE por dentro"
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <video
                src={embed.src}
                controls
                preload="metadata"
                playsInline
                className="w-full h-full object-contain"
              />
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
